// src/components/About.js
import React from 'react';
import BlurText from './main/BlurText';
import IndiaAbout from './ui/IndiaAbout';
const About = () => {
  return (<>
          <IndiaAbout/>
    <section id="about-section" className="about-wrapper">
      <div className="about-inner-container">
       


        <div className="about-card">
          <h3 className="card-heading">Who We Are</h3>
          <p>
            We are a technical training institute focusing on <strong>IT infrastructure, networking, cybersecurity</strong>, and
            <strong> digital forensics</strong>. Our training prepares you for both <strong>certifications and real jobs</strong>.
          </p>
        </div>

        <div className="about-card">
          <h3 className="card-heading">Our Courses</h3>
          <ul className="course-list">
            <li><strong>CompTIA A+</strong> – Hardware, troubleshooting, OS installation.</li>
            <li><strong>CCNA</strong> – Routing, switching, and enterprise networking.</li>
            <li><strong>Ethical Hacking</strong> – Pentesting with legal & ethical practices.</li>
            <li><strong>Forensic Investigation</strong> – Evidence handling and data recovery.</li>
          </ul>
        </div>

        <div className="about-card">
          <h3 className="card-heading">About the Trainer</h3>
          <p>
            With only 6 Month-1 Year of classroom and lab experience, I help students use <strong>real-world tools and workflows</strong>
            to prepare for interviews and on-the-job tasks.
          </p>
        </div>

        <div className="about-card">
          <h3 className="card-heading">Why Choose Us?</h3>
          <ul className="why-list">
            <li>Practical Labs</li>
            <li> Certification-Oriented Curriculum</li>
            <li> Small Batch Sizes</li>
            <li> Placement Guidance</li>
            <li> Ethical & Legal Cybersecurity Training</li>
          </ul>
        </div>

        <div className="about-card mission-card">
          <h3 className="card-heading">Our Mission</h3>
          <p>
            To empower Indore’s tech talent with <strong>globally-relevant IT and cybersecurity skills</strong> — ensuring
            you earn both a <strong>certificate</strong> and <strong>confidence</strong>.
          </p>
        </div>

        
      </div>
    </section>

</>);
};

export default About;
